import React from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

// The two send checkboxes in the Job Setup footer, left of Cancel / Save & Send.
// Each is shown only when ticking it would create a new artifact on that track —
// already-sent contracts and payment links are managed from the Job Detail page.
// Purely presentational: tier, Stripe and required-field gating is computed by
// JobSetupModal via sendTrackRules and passed in.

const MaybeTooltip = ({ text, children }) =>
  text ? (
    <OverlayTrigger placement="top" overlay={<Tooltip>{text}</Tooltip>}>
      <span className="d-inline-block">{children}</span>
    </OverlayTrigger>
  ) : (
    children
  );

const SendCheckbox = ({ id, label, checked, disabled, tooltip, onToggle }) => (
  <MaybeTooltip text={tooltip}>
    <Form.Check
      type="checkbox"
      id={id}
      label={label}
      checked={checked}
      disabled={disabled}
      onChange={() => onToggle(!checked)}
      className="job-setup-send-checkbox"
    />
  </MaybeTooltip>
);

const JobSetupSendTracks = ({ contract, payment }) => {
  if (!contract?.show && !payment?.show) return null;

  return (
    <div className="job-setup-send-checkboxes">
      {contract?.show && (
        <SendCheckbox
          id="send-contract-checkbox"
          label={contract.label || "Contract"}
          checked={contract.checked}
          disabled={contract.disabled}
          tooltip={contract.tooltip}
          onToggle={contract.onToggle}
        />
      )}
      {payment?.show && (
        <SendCheckbox
          id="send-payment-checkbox"
          label={payment.label || "Payment Request"}
          checked={payment.checked}
          disabled={payment.disabled}
          tooltip={payment.tooltip}
          onToggle={payment.onToggle}
        />
      )}
    </div>
  );
};

export default JobSetupSendTracks;
